import React, {useId} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, FontVariant, IconTypes, Row, Text} from '@pexip/components';
import type {MediaDeviceInfoLike, IndexedDevices} from '@pexip/media-control';

import {DeviceSelect} from '../DeviceSelect/DeviceSelect.view';
import {TestId} from '../../../test/testIds';

import styles from './MicrophoneMonitorModal.module.scss';

export const BeforeTestingYourMic: React.FC<{
    devices: IndexedDevices;
    selectedAudioInput?: MediaDeviceInfoLike;
    onAudioInputChange: (id: string) => void;
    startTest: () => void;
}> = ({devices, selectedAudioInput, onAudioInputChange, startTest}) => {
    const {t} = useTranslation();
    const startTestDescriptionId = useId();

    return (
        <>
            <Row>
                <Text fontVariant={FontVariant.H6}>
                    {t(
                        'media.first-check-that-you-have-selected-microphone',
                        'First, check that you have selected the correct microphone and that your volume is turned up.',
                    )}
                </Text>
            </Row>
            <Row className="p-0 mt-4">
                <DeviceSelect
                    isDisabled={false}
                    kind="audioinput"
                    onDeviceChange={onAudioInputChange}
                    selected={selectedAudioInput}
                    iconType={IconTypes.IconMicrophoneOn}
                    label={t(
                        'settings.device-select.select-microphone',
                        'Select microphone',
                    )}
                    devices={devices}
                    className={styles.audioSelect}
                    sizeModifier="medium"
                    data-testid={TestId.SelectTestAudioInput}
                />
            </Row>
            <Row className="p-0 mt-10 justify-content-center">
                <Text id={startTestDescriptionId} variant="hidden">
                    {t(
                        'media.start-test-description',
                        'Starts a three-second countdown. When it ends, begin speaking to record your microphone.',
                    )}
                </Text>
                <Button
                    aria-describedby={startTestDescriptionId}
                    onClick={startTest}
                    size="large"
                    data-testid={TestId.ButtonTestAudioInputStart}
                >
                    {t('media.start-test', 'Start test')}
                </Button>
            </Row>
        </>
    );
};
